import { render, staticRenderFns } from "./HomePage.vue?vue&type=template&id=38bada37&"
import script from "./HomePage.vue?vue&type=script&lang=ts&"
export * from "./HomePage.vue?vue&type=script&lang=ts&"
import style0 from "./HomePage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports